// en_pms_groups.ts
// Tłumaczenia dla PMS.Groups.tsx

export const enPmsGroups = {

  title:       "Groups and events",
  description: "Operacyjny przegląd rezerwacji grupowych i powiązanych wydarzeń.",
  filters:     "Filtry",
  filtersHint: "Szybko zawęź rezerwacje grupowe z dużą liczbą wydarzeń.",
  none:        "None",

} as const;

export default enPmsGroups;
